import * as React from 'react';
import { Modal } from 'src/modules/common/components/Modal';

type Props = {
  readonly in?: boolean;
  readonly children: React.ReactNode;
};

/* eslint-disable react/destructuring-assignment */
export const ModalWrapper = (props: Props): React.ReactElement => (
  <Modal
    opened={props.in ?? false}
    handleClose={() => false}
    size="md"
  >
    {props.children}
  </Modal>
);
